module.exports = __webpack_public_path__ + "static/media/Barlow.2cce8c80.ttf";